import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
  mode: "history",
  routes: [{
    path: '/',
    name: 'index',
    component: resolve => require(['@/pages/index'], resolve)
  }, {
    path: '/index',
    name: 'index',
    component: resolve => require(['@/pages/index'], resolve)
  }, {
    path: '/bylaws',
    name: 'bylaws',
    component: resolve => require(['@/pages/bylaws'], resolve)
  },
  {
    path: '/journal',
    name: 'journal',
    component: resolve => require(['@/pages/journal'], resolve)
  }, {
    path: '/naHsien',
    name: 'naHsien',
    component: resolve => require(['@/pages/naHsien'], resolve)
  }, {
    path: '/support',
    name: 'support',
    component: resolve => require(['@/pages/support'], resolve)
  }, {
    path: '/research',
    name: 'research',
    component: resolve => require(['@/pages/research'], resolve)
  }, {
    path: '/dynamics',
    name: 'dynamics',
    component: resolve => require(['@/pages/dynamics'], resolve)
  }, {
    path: '/affairs',
    name: 'affairs',
    component: resolve => require(['@/pages/affairs'], resolve)
  }, {
    path: '/hotspot/:id',
    name: 'hotspot',
    component: resolve => require(['@/pages/hotspot'], resolve)
  }, {
    path: '/details/:id',
    name: 'details',
    component: resolve => require(['@/pages/details'], resolve),
    alias:'/articles/:id'
  }, {
    path: '/search/:id',
    name: 'search',
    component: resolve => require(['@/pages/search'], resolve)
  }, {
    path: '/privacyPolicy/:id',
    name: 'privacyPolicy',
    component: resolve => require(['@/pages/privacyPolicy'], resolve)
  }
  ]
})
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js